import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import type UnmarkWorkflowRunHandled from '@Application/WorkflowRuns/Handling/Commands/UnmarkWorkflowRunHandled';
import workflowRunUnhandled, {
	type WorkflowRunUnhandledAction,
} from '@Application/WorkflowRuns/Handling/Actions/workflowRunUnhandled';
import workflowRunHandlingFailed, {
	type WorkflowRunHandlingFailedAction,
} from '@Application/WorkflowRuns/Handling/Actions/workflowRunHandlingFailed';
import type { FacilityWorkflowRunPayload } from '@Application/WorkflowRuns/FacilityWorkflowRuns/Actions/facilityWorkflowRunsFetched';
import { del } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = WorkflowRunUnhandledAction | WorkflowRunHandlingFailedAction;

export default (command: UnmarkWorkflowRunHandled) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await del<FacilityWorkflowRunPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/workflow-runs/${command.runId}/handling`,
			);

			const action = workflowRunUnhandled(payload, command.facilityId, command.subject.subjectId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowRunHandlingFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
